"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breakpoints = void 0;
const react_1 = require("react");
exports.Breakpoints = {
    // $small-breakpoint:  40em !default;
    Small: 40,
    // $medium-breakpoint: 73em !default;
    Medium: 73,
    // $large-breakpoint:  96em !default;
    Large: 96,
    // $Widthlarge-breakpoint: 120em !default;
    WidthLarge: 120,
};
const getWidth = () => { var _a; return typeof window === "undefined" ? 0 : (_a = window.innerWidth) !== null && _a !== void 0 ? _a : 0; };
const getHeight = () => { var _a; return typeof window === "undefined" ? 0 : (_a = window.innerHeight) !== null && _a !== void 0 ? _a : 0; };
const getFontSize = () => typeof window === "undefined" ? 16 : parseFloat(getComputedStyle(document.body)["fontSize"]);
const useSize = () => {
    const requestId = (0, react_1.useRef)();
    const lastSizeWidth = (0, react_1.useRef)(0);
    const lastSizeHeight = (0, react_1.useRef)(0);
    const Width = getWidth();
    const Height = getHeight();
    const fontSize = getFontSize();
    const [sizeWidth, setWidth] = (0, react_1.useState)(Width);
    const [sizeHeight, setHeight] = (0, react_1.useState)(Height);
    const [sizeWidthInEms, setWidthInEms] = (0, react_1.useState)(Width / fontSize);
    const [sizeHeightInEms, setHeightInEms] = (0, react_1.useState)(Height / fontSize);
    const [sizeWidthDirection, setSizeWidthDirection] = (0, react_1.useState)();
    const [sizeHeightDirection, setSizeHeightDirection] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        const resizeHandler = () => {
            if (requestId.current)
                cancelAnimationFrame(requestId.current);
            requestId.current = requestAnimationFrame(() => {
                const fontSize = parseFloat(getComputedStyle(document.body)["fontSize"]);
                const Width = getWidth();
                setWidth(Width);
                setWidthInEms(Width / fontSize);
                setSizeWidthDirection(lastSizeWidth.current > Width ? "shrink" : "grow");
                lastSizeWidth.current = Width;
                const Height = getHeight();
                setHeight(Height);
                setHeightInEms(Height / fontSize);
                setSizeHeightDirection(lastSizeHeight.current > Height ? "shrink" : "grow");
                lastSizeHeight.current = Height;
            });
        };
        window.addEventListener("resize", resizeHandler);
        return () => {
            window.removeEventListener("resize", resizeHandler);
        };
    }, []);
    return {
        sizeWidth,
        sizeHeight,
        sizeWidthInEms,
        sizeHeightInEms,
        sizeWidthDirection,
        sizeHeightDirection,
    };
};
exports.default = useSize;
